import axios from 'axios'
import { LoggedUser } from 'BrokerTsLib/src/dtos'
import { useQuery } from 'react-query'

import { GenericQueryOptions } from '.'

const baseUrl = process.env.PUBLIC_URL
const carkulkaUrl = process.env.REACT_APP_CARKULKA_URL
const apiUrl = process.env.REACT_APP_ACCOUNT_API
const url = `${baseUrl}/${apiUrl}`

export const loginUrl = `${url}/Login`
export const logoutUrl = `${url}/Logout`

const isLoggedFetch = () => axios.get<LoggedUser>(`${url}/IsLogged`)
const isLoggedCarkulkaFetch = () =>
  axios.get<LoggedUser>(`${carkulkaUrl}/Account/IsLogged`, {
    withCredentials: true,
  })

export const useIsLogged = (options?: GenericQueryOptions<LoggedUser>) =>
  useQuery('isLogged', () => isLoggedFetch(), { retry: false, ...options })
export const useIsLoggedCarkulka = (
  options?: GenericQueryOptions<LoggedUser>,
) =>
  useQuery('isLoggedCarkulka', () => isLoggedCarkulkaFetch(), {
    retry: false,
    ...options,
  })

export const isAuthenticated = async () => {
  const resp = await isLoggedFetch()

  return resp.data
}

export const redirectToLogin = () => {
  window.location.replace(`${loginUrl}?returnUrl=${window.location.href}`)
}
export const redirectToLogout = () => {
  const url = getLogoutUrl()

  window.location.replace(url)
}

export const getLogoutUrl = () => {
  let returnUrl = window.location.origin
  if (!returnUrl.endsWith('/') && !baseUrl.startsWith('/')) returnUrl += '/'

  returnUrl += baseUrl

  return `${logoutUrl}?returnUrl=${returnUrl}`
}
